/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathAvg = createReactComponent("outline", "math-avg", "IconMathAvg", [["path", { "d": "M3 21l18 -18", "key": "svg-0" }], ["path", { "d": "M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0", "key": "svg-1" }]]);

export { IconMathAvg as default };
//# sourceMappingURL=IconMathAvg.mjs.map
